import update from 'immutability-helper';
import { StaticSessionEmailEnum, StaticSessionEmailNotifications } from './SessionEmailConstants';

const initialState = {
  emailSendError: null,
  isEmailModalOpen: false,
};

const SessionEmailReducer = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    case StaticSessionEmailEnum.STATIC_BUILDER_EMAIL_MODAL_OPEN:
      return update(state, {
        isEmailModalOpen: { $set: true },
      });
    case StaticSessionEmailEnum.STATIC_BUILDER_EMAIL_MODAL_CLOSE:
      return update(state, {
        isEmailModalOpen: { $set: false },
      });
    case StaticSessionEmailEnum.STATIC_BUILDER_SEND_SESSION_LINK_EMAIL_FAILURE:
      return update(state, {
        emailSendError: { $set: StaticSessionEmailNotifications.failure },
      });
    case StaticSessionEmailEnum.STATIC_BUILDER_SEND_SESSION_LINK_EMAIL_SUCCESS:
      return update(state, {
        emailSendError: { $set: null },
      });
    default:
      return state;
  }
};

export default SessionEmailReducer;



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/SessionEmail/SessionEmailReducer.jsx